import { useMemo } from "react";
import {
  TbBrandWhatsapp,
  // TbPlayerPlayFilled,
} from "react-icons/tb";
import styles from "../_shared/productLanding.module.css";
import { Link } from "react-router-dom";
import PlansComponent from "../../components/Plans/PlansComponent";
import SeoHead from "../../components/Seo/SeoHead";
import {
  TRIAL_PRODUCTS,
  buildTrialSignupPath,
} from "../../constants/trialProduct";
import WhatsAppMockup from "../../components/Marketing/WhatsAppMockup";
import FaqAccordion from "../../components/Marketing/FaqAccordion";
import TestimonialBlock from "../../components/Marketing/TestimonialBlock";
// import VideoSection from "../../components/VideoSection/VideoSection";
// import VideoModal from "../../components/VideoModal/VideoModal";
import {
  BUSINESS_SEGMENTS,
  CTA_PAGES,
  CTA_PLACEMENTS,
  DESTINATIONS,
  trackTrialCtaClick,
} from "../../analytics";

// HeroBanner e HealthBeautySection continuam existindo mas não são usados aqui
// para evitar o H1 duplicado e a estrutura genérica

const WHATSAPP_PHONE = "5551992747402";

/** Contexto fixo desta página para o funil de teste grátis (GA4). */
const CTA_CTX = {
  cta_page: CTA_PAGES.ATENDIMENTO,
  business_segment: BUSINESS_SEGMENTS.GENERAL,
  destination: DESTINATIONS.LOGIN_SIGNUP,
  // Quem chega por esta página JÁ escolheu o produto: os CTAs vão direto
  // ao cadastro, sem passar pelo modal da home.
  product: TRIAL_PRODUCTS.ATENDIMENTO,
};

/** Destino dos CTAs — carrega o produto para o signup escolher o plano certo. */
const SIGNUP_PATH = buildTrialSignupPath(TRIAL_PRODUCTS.ATENDIMENTO);

// const YOUTUBE_ID = "lkcbXYnJAR8"; // vídeo de apresentação — https://youtu.be/lkcbXYnJAR8

/**
 * ⚠️ Os passos abaixo descrevem o tier de ATENDIMENTO, que não agenda, não
 * remarca, não cancela e não envia lembrete de agenda. Copy que sugira qualquer
 * uma dessas ações pertence a `/agendamento`, não a esta página.
 */
const HOW_IT_WORKS = [
  {
    step: "1",
    title: "Conecte seu WhatsApp",
    text: "Em menos de 5 minutos, seu número já responde automaticamente.",
  },
  {
    step: "2",
    title: "Cadastre as informações do seu negócio",
    text: "Serviços, preços, horários e as dúvidas que seus clientes mais fazem — escritos em português, pelo painel.",
  },
  {
    step: "3",
    title: "Receba clientes respondidos e contatos registrados",
    text: "Quem chama recebe resposta na hora e vira contato no seu painel. O que precisar de gente, a Nexus passa para a sua equipe.",
  },
];

const FEATURES = [
  {
    title: "Não perca nenhum contato",
    text: "O bot cuida da resposta para o seu cliente se manter aquecido.",
  },
  {
    title: "Cliente tem resposta, mesmo às 20h de domingo",
    text: "Sem depender de você estar online. O bot atende 24/7.",
  },
  {
    title: "Responde as dúvidas que você cadastrar",
    text: "Você escreve pergunta e resposta pelo painel, e a Nexus responde com o que está cadastrado.",
  },
];

/**
 * Conversa do mockup. Demonstra o que ESTE tier faz: responde a informação
 * cadastrada e, quando a situação foge disso, encaminha para uma pessoa. Não
 * pode terminar em horário marcado — isso é `/agendamento`.
 *
 * O valor de R$ 80 é ilustrativo do negócio do assinante (o preço que ELE
 * cadastra), não é preço da Nexus nem dado real de nenhum cliente.
 */
const DEMO_MESSAGES = [
  {
    type: "out",
    text: "Oi, vocês atendem no domingo e quanto custa a avaliação?",
  },
  {
    type: "in",
    text: "Aos domingos não abrimos. A avaliação custa R$ 80 e atendemos de segunda a sábado.",
  },
  { type: "out", text: "Preciso explicar uma situação diferente." },
  {
    type: "in",
    text: "Entendi. Vou encaminhar sua conversa para uma pessoa da equipe continuar com você por aqui.",
  },
];

/** O que a Nexus responde sozinha — sempre a partir do que o assinante cadastra. */
const ANSWERABLE = [
  {
    title: "Horário de funcionamento",
    text: "Que dias você abre, a que horas fecha e o que muda no fim de semana ou no feriado.",
  },
  {
    title: "Endereço e como chegar",
    text: "Onde fica, ponto de referência, se tem estacionamento. O que você cadastrar, ela informa.",
  },
  {
    title: "Formas de pagamento",
    text: "Quais formas o seu negócio aceita, do jeito que você escreveu. A Nexus informa; quem recebe é você.",
  },
  {
    title: "Serviços que você oferece",
    text: "A lista do que o seu negócio faz, com a explicação que você deu para cada item.",
  },
  {
    title: "Preços cadastrados",
    text: "Quanto custa cada serviço, na hora em que perguntam. Mudou o preço no painel, muda na resposta.",
  },
  {
    title: "Promoções vigentes",
    text: "Promoção tem data de validade: passou a data, a Nexus para de mencionar sozinha.",
  },
  {
    title: "Perguntas frequentes",
    text: "Aquelas cinco ou seis perguntas que você responde todo dia, escritas uma vez e respondidas sempre.",
  },
  {
    title: "As mesmas respostas no Instagram",
    text: "Quem chama no Instagram Direct recebe as mesmas informações, sem você cadastrar tudo de novo.",
  },
];

const FAQ_ITEMS = [
  {
    question: "O que exatamente o bot responde?",
    answer:
      "O que você ensinar a ele: horário de funcionamento, endereço, formas de pagamento, se atende no domingo, se tem estacionamento — o que seus clientes mais perguntam. Ele também informa o preço dos serviços que você cadastrar, na hora que o cliente perguntar.",
  },
  {
    question: "Como eu ensino as respostas pra ele?",
    answer:
      "Pelo painel, escrevendo pergunta e resposta em português. Nada de fluxo ou código. Dá também pra cadastrar promoções com data de validade: passou a data, o bot para de mencionar sozinho — você não precisa lembrar de apagar.",
  },
  {
    question: "E quando ele não souber responder?",
    answer:
      "Ele não inventa. Reconhece que aquilo é assunto para uma pessoa, diz isso ao cliente e encaminha a conversa para a sua equipe ali mesmo, no WhatsApp — sem prometer prazo que ninguém combinou.",
  },
  {
    question: "Ele agenda horário para o cliente?",
    answer:
      "Não. Este é o chatbot de Atendimento: ele responde, informa preços e capta contatos, mas não mexe em agenda. Se o seu negócio trabalha com hora marcada, o Chatbot de Agendamento faz tudo isso e ainda cuida da agenda — e você pode trocar de plano quando quiser, sem perder o que já configurou.",
  },
  {
    question: "Ele guarda o contato de quem chamou?",
    answer:
      "Guarda. Cada pessoa que conversa vira um contato no seu painel, com o que ela perguntou. Mesmo quem não fechou nada na hora fica registrado — é a sua lista para chamar de volta depois.",
  },
  {
    question: "Posso cancelar quando quiser?",
    answer:
      "Sim. Sem fidelidade, sem multa e sem taxa de adesão — você cancela pelo painel. O teste de 14 dias também não pede cartão.",
  },
];

const ORG_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Nexus Chatbot",
  url: "https://nexustech.tec.br",
  logo: "https://nexustech.tec.br/logo_nexus_sem_fundo.png",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+55-51-99274-7402",
    contactType: "customer service",
    email: "contato@nexustech.tec.br",
  },
};

const FAQ_LD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ_ITEMS.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
};

const Home = () => {
  // const [videoOpen, setVideoOpen] = useState(false);
  // const openVideo = useCallback(() => setVideoOpen(true), []);
  // const closeVideo = useCallback(() => setVideoOpen(false), []);

  const waHref = useMemo(() => {
    const page =
      typeof window !== "undefined"
        ? window.location.href
        : "https://nexustech.tec.br";
    const text = `Olá! Gostaria de falar com a equipe da Nexus Tech via site. \n\nPágina:${page}`;
    return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(text)}`;
  }, []);

  return (
    <>
      <SeoHead
        title="Atendimento Automático no WhatsApp com IA | Nexus"
        description="Responda dúvidas, preços e horários automaticamente no WhatsApp e Instagram. A IA transfere para sua equipe quando necessário. Teste grátis por 14 dias."
        canonical="https://nexustech.tec.br/atendimento"
        ogImage="https://nexustech.tec.br/og-home.jpg"
        // O `FAQPage` volta a ser emitido porque as três páginas passaram a ter
        // perguntas PRÓPRIAS. Enquanto o conjunto era idêntico nas três, três
        // URLs declarando a mesma marcação faziam o Google escolher uma e
        // descartar o resto — mesmo efeito do canonical duplicado. Se um dia
        // alguém copiar o FAQ de uma página para a outra, este comentário é o
        // aviso de que a marcação precisa sair junto.
        jsonLd={[ORG_LD, FAQ_LD]}
      />

      <main className={styles.main} role="main">
        {/* ── SEÇÃO 1: HERO ── */}
        <section className={styles.heroSection}>
          <div className={`${styles.contentWide} ${styles.heroLayout}`}>
            <div className={styles.heroText}>
              <h1 className={styles.heroH1}>
                Atendimento automático no WhatsApp, 24 horas por dia
              </h1>
              <p className={styles.heroH1Subtext}>
                Para pequenas empresas que não querem perder o cliente.
              </p>
              <p className={styles.heroSubtitle}>
                Seus clientes não ficam mais sem uma resposta sobre o seu
                negócio.
              </p>

              <div className={styles.heroCtas}>
                <Link
                  to={SIGNUP_PATH}
                  className={styles.ctaPrimary}
                  onClick={() =>
                    trackTrialCtaClick({
                      ...CTA_CTX,
                      cta_placement: CTA_PLACEMENTS.HERO,
                    })
                  }
                >
                  Começar meu teste grátis
                </Link>
                <a href="#como-funciona" className={styles.ctaSecondary}>
                  Ver como funciona
                </a>
                {/* Sem aria-label: o nome acessível é o texto visível
                    ("Ver apresentação") — WCAG 2.5.3 Label in Name. */}
                {/*<button
                  type="button"
                  className={styles.ctaWatch}
                  onClick={openVideo}
                >
                  <TbPlayerPlayFilled
                    className={styles.ctaWatchIcon}
                    aria-hidden="true"
                  />
                  Ver apresentação
                </button>*/}
              </div>

              <p className={styles.heroCopy}>
                Sem cartão. Cancele quando quiser. Configuração em 15 minutos.
              </p>
            </div>

            <div className={styles.heroMockup}>
              <WhatsAppMockup messages={DEMO_MESSAGES} looping />
            </div>
          </div>
        </section>

        {/* ── SEÇÃO 1.5: VÍDEO DE APRESENTAÇÃO ── Reativar quando existir vídeo específico de Atendimento”
        <VideoSection
          onPlay={openVideo}
          subtitle="Sem enrolação: como o robô responde seu cliente no WhatsApp e no Instagram."
        />*/}

        {/* ⚠️ Sem seção "Para quem é": o grid de segmentos e a nota do NextFit
            vendem AGENDA — as 5 páginas de segmento tratam de quem atende com
            hora marcada, e a integração NextFit lê agenda e contratos. Nada
            disso existe neste tier. Elas vivem em `/agendamento`. */}

        {/* ── SEÇÃO 2.5: O QUE É (pilar de busca long-tail) ── */}
        <section className={styles.tintedSection}>
          <div className={styles.contentNarrow}>
            <h2 className={styles.sectionHeading}>
              O que é atendimento automático no WhatsApp?
            </h2>
            <p className={styles.sectionSubtitle}>
              É ter alguém respondendo o seu cliente na hora, mesmo quando não
              tem ninguém livre para olhar o celular. A Nexus responde as
              dúvidas que você cadastrar, informa os serviços e os preços que
              estão no seu painel e conversa em português — sem menu de números,
              sem “digite 1”.
            </p>
            <p className={styles.sectionSubtitle}>
              Ela atende fora do horário comercial, de madrugada, no domingo e
              no feriado, e registra o contato de quem chamou junto com o que a
              pessoa perguntou. E não é só no WhatsApp: quem manda mensagem no
              Instagram Direct recebe a mesma resposta.
            </p>
          </div>
        </section>

        {/* ── SEÇÃO 3: COMO FUNCIONA ── */}
        <section id="como-funciona" className={styles.plainSection}>
          <div className={styles.contentNarrow}>
            <h2 className={styles.sectionHeading}>
              Configuração em 15 minutos. Funciona em segundos.
            </h2>

            <div className={styles.stepsGrid}>
              {HOW_IT_WORKS.map((item) => (
                <div key={item.step} className={styles.step}>
                  <div className={styles.stepCircle}>{item.step}</div>
                  <h3 className={styles.stepTitle}>{item.title}</h3>
                  <p className={styles.stepText}>{item.text}</p>
                </div>
              ))}
            </div>

            <div className={styles.ctaBlock}>
              <Link
                to={SIGNUP_PATH}
                className={styles.ctaPrimary}
                onClick={() =>
                  trackTrialCtaClick({
                    ...CTA_CTX,
                    cta_placement: CTA_PLACEMENTS.MIDDLE,
                  })
                }
              >
                Quero usar no meu negócio
              </Link>
            </div>
          </div>
        </section>

        {/* ── SEÇÃO 4: RECURSOS ── */}
        <section className={styles.tintedSection}>
          <div className={styles.contentNarrow}>
            <h2 className={styles.sectionHeading}>
              Tudo o que seu atendimento precisa, num só chat
            </h2>

            <div className={styles.featuresGrid}>
              {FEATURES.map((feat) => (
                <div key={feat.title} className={styles.featureCard}>
                  <h3 className={styles.featureTitle}>{feat.title}</h3>
                  <p className={styles.featureText}>{feat.text}</p>
                </div>
              ))}
            </div>

            <div className={styles.ctaBlock}>
              <Link
                to={SIGNUP_PATH}
                className={styles.ctaPrimary}
                onClick={() =>
                  trackTrialCtaClick({
                    ...CTA_CTX,
                    cta_placement: CTA_PLACEMENTS.FEATURES,
                  })
                }
              >
                Ativar meu chatbot agora
              </Link>
            </div>
          </div>
        </section>

        {/* ── SEÇÃO 4.5: O QUE ELA RESPONDE ── */}
        <section className={styles.plainSection}>
          <div className={styles.contentNarrow}>
            <h2 className={styles.sectionHeading}>
              O que a Nexus pode responder automaticamente
            </h2>

            <div className={styles.featuresGrid}>
              {ANSWERABLE.map((item) => (
                <div key={item.title} className={styles.featureCard}>
                  <h3 className={styles.featureTitle}>{item.title}</h3>
                  <p className={styles.featureText}>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── SEÇÃO 4.6: QUANDO A IA NÃO SABE ── */}
        <section className={styles.tintedSection}>
          <div className={styles.contentNarrow}>
            <h2 className={styles.sectionHeading}>
              Quando a IA não sabe responder
            </h2>
            <p className={styles.sectionSubtitle}>
              Nenhuma IA sabe tudo sobre o seu negócio, e a Nexus não finge que
              sabe. Se a pergunta cai fora do que você cadastrou, ela não
              inventa resposta: nem preço, nem prazo, nem promessa que você
              teria de cumprir depois.
            </p>
            <p className={styles.sectionSubtitle}>
              O que ela faz é reconhecer que aquilo é assunto para uma pessoa,
              dizer isso ao cliente com todas as letras e encaminhar a conversa
              para a sua equipe. O atendimento humano continua no WhatsApp, na
              mesma conversa e com o histórico do que já foi dito — o cliente
              não precisa repetir nada.
            </p>
          </div>
        </section>

        {/* ── SEÇÃO 5: PROVA SOCIAL ── */}
        {/* TestimonialBlock retorna null se array vazio — não renderiza placeholder */}
        <TestimonialBlock testimonials={[]} />

        {/* ── SEÇÃO 6: PRICING ── */}
        <section id="planos" className={styles.plainSection}>
          <div className={styles.contentWide}>
            <h2 className={styles.sectionHeading}>
              Planos que cabem no caixa de quem tá começando
            </h2>
            <p className={styles.pricingSubtitle}>
              Sem contrato. Sem taxa de adesão. Cancele quando quiser.
            </p>
            <PlansComponent />
          </div>
        </section>

        {/* ── SEÇÃO 7: FAQ ── */}
        <section className={styles.tintedSection}>
          <div className={styles.contentNarrowest}>
            <h2 className={styles.sectionHeading}>
              Perguntas que todo mundo faz
            </h2>
            <FaqAccordion items={FAQ_ITEMS} />
            {/* Bloco E: botão "Falar no WhatsApp" removido — FAB já é onipresente */}
          </div>
        </section>

        {/* ── SEÇÃO 8: ATENDIMENTO OU AGENDAMENTO ── */}
        <section className={styles.plainSection}>
          <div className={styles.contentNarrow}>
            <h2 className={styles.sectionHeading}>
              Atendimento ou Agendamento?
            </h2>
            <p className={styles.sectionSubtitle}>
              O Atendimento responde dúvidas, informa os seus serviços e preços
              e registra o contato de quem chamou. É o bastante para quem atende
              por ordem de chegada, vende produto ou só quer parar de perder
              mensagem.
            </p>
            <p className={styles.sectionSubtitle}>
              O Agendamento faz tudo isso e ainda cuida da agenda: o cliente
              consulta os horários livres, escolhe o profissional, marca,
              remarca, cancela e recebe lembrete. Se o seu negócio trabalha com
              hora marcada, é esse o produto que você precisa conhecer.
            </p>
            <p className={styles.sectionSubtitle}>
              Dá para trocar de plano depois, sem perder o que você já
              configurou.
            </p>

            <div className={styles.ctaBlock}>
              {/* Sem aria-label: o nome acessível é o texto visível
                  — WCAG 2.5.3 Label in Name. */}
              <Link to="/agendamento#planos" className={styles.ctaSecondary}>
                Ver planos com agendamento
              </Link>
            </div>
          </div>
        </section>

        {/* ── CTA FINAL ── */}
        <section className={styles.ctaFinalSection}>
          <div className={styles.contentCenter}>
            <h2 className={styles.ctaFinalHeading}>
              Pronto para deixar de atender telefone manualmente?
            </h2>
            <p className={styles.ctaFinalText}>
              14 dias grátis. Sem cartão. Cancelamento a qualquer momento.
            </p>
            <div className={styles.ctaFinalCtas}>
              <Link
                to={SIGNUP_PATH}
                className={styles.ctaFinalBtn}
                onClick={() =>
                  trackTrialCtaClick({
                    ...CTA_CTX,
                    cta_placement: CTA_PLACEMENTS.FINAL,
                  })
                }
              >
                Começar grátis por 14 dias
              </Link>
              <a
                href={waHref}
                className={styles.ctaFinalWhats}
                target="_blank"
                rel="noopener noreferrer"
              >
                <TbBrandWhatsapp aria-hidden="true" />
                Falar no WhatsApp
              </a>
            </div>
          </div>
        </section>

        {/* ── WHATSAPP FAB (fixo) ── */}
        <a
          href={waHref}
          className={styles.whatsappFab}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Abrir conversa no WhatsApp"
        >
          <TbBrandWhatsapp className={styles.whatsappIcon} aria-hidden="true" />
          <span className={styles.srOnly}>Conversar no WhatsApp</span>
        </a>
      </main>

      {/* Modal do vídeo — fora do <main> por ser conteúdo sobreposto
      <VideoModal
        open={videoOpen}
        youtubeId={YOUTUBE_ID}
        onClose={closeVideo}
      />*/}
    </>
  );
};

export default Home;
